// extracted by mini-css-extract-plugin
module.exports = {"hoverableDropdown":"_1pDfrU","icon":"_1B05-5 mz-primary-icon"};